/**
 * 에디터 공통 core 의 Host 차이 흡수 경계 (Host injection).
 *
 * 공통 core 는 빌드 상수(Vite `import.meta.env` / `__ENV_PRODUCTION__`)나 Host capability 를
 * 직접 알지 못한다. 각 Host 앱이 엔트리에서 `setEditorHostEnv(...)` 로 1회 주입하고, core 는
 * getter 로만 읽는다. 미주입 시 기본값은 안전한 일반 브라우저(web) 동작이다(dev=false · guard off).
 * 이 injection 경계 덕분에 editor core 파일은 platform·web 에서 byte 동일하게 유지된다.
 *
 * ① `isDev()` — dev 전용 가드(개발 중 assert·경고 로그)의 조건. prod 판정 빌드 상수가 Host 마다
 *    다르므로(platform=`!import.meta.env.PROD`, web=`!__ENV_PRODUCTION__`) 그 값을 Host 가 주입한다.
 * ② `needsLinkClickGuard()` — 편집 중 `<a>` 클릭의 기본 네비게이션(브라우저 열림)을 core 가
 *    차단해야 하는가. platform(Tauri/wry)은 `target="_blank"` 링크를 WKWebView new-window 경로로
 *    OS 브라우저에 자동으로 열고 DOM `preventDefault` 로도 취소되지 않아 `true`. 일반 브라우저(web)는
 *    링크 클릭 네비게이션 자체가 없고 guard 를 걸면 ctrl/middle-click 새 탭 열기를 없애므로 `false`.
 *    자세한 근거는 `NgwEditorLifecycle.attachLinkClickGuard` 주석 참조.
 *
 * 주입 예:
 * - platform(Tauri): `setEditorHostEnv({ isDev: !import.meta.env.PROD, needsLinkClickGuard: true })`
 * - web: `setEditorHostEnv({ isDev: !__ENV_PRODUCTION__, needsLinkClickGuard: false })`
 */
let hostIsDev = false
let hostNeedsLinkClickGuard = false

/** Host(앱 엔트리)가 editor core 의 Host 의존 값을 주입한다. 렌더 이전 1회 호출. */
export function setEditorHostEnv(env: { isDev?: boolean; needsLinkClickGuard?: boolean }): void {
  if (env.isDev !== undefined) hostIsDev = env.isDev
  if (env.needsLinkClickGuard !== undefined) hostNeedsLinkClickGuard = env.needsLinkClickGuard
}

/** dev 빌드 여부 (Host 주입값, 미주입 시 false). */
export function isDev(): boolean {
  return hostIsDev
}

/** 편집 중 링크 클릭 기본 네비게이션을 core 가 차단해야 하는가 (Host 주입값, 미주입 시 false). */
export function needsLinkClickGuard(): boolean {
  return hostNeedsLinkClickGuard
}
